import React from "react";
import { Card, CardBody, Container, Row, Col, Button } from "reactstrap";
import { getStats } from "../../components/helpers/StatsHelpers";
import { RiFolderMusicLine } from "react-icons/ri";
import { SeoHelper } from "../../components/helpers/SeoHelper";
import InstructionsWizard from "./InstructionsWizard";

class SavingAndManagingYourSongFlowsHelp extends React.Component {
  state = { songBookCount: null };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  stepsData = [
    {
      title: "Saving and managing your song-flows",
      description:
        "At the end of this guide you will be able to:<br/><br/>" +
        "<img src=\"/help-images/blue-arrow.png\" style=\"width: 40px; height: auto;\">&nbsp;" +
        "save a song-flow to your account and access it again at any time" +
        "<br/><br/><b>Please note:</b> saving song-flows requires a paid account. " +
        "Free accounts can build and share song-flows but cannot save them. <a href='/register/choose-your-plan'>Register here</a> to get started.",
    },
    {
      title: "Sign in to your account",
      description:
        "To save a song-flow, you must be signed in. Click your name in the top-right navigation bar, or go to the <a href='/sign-in'>sign-in page</a>. " +
        "If you do not yet have an account, <a href='/register/choose-your-plan'>register here</a>.",
    },
    {
      title: "Build a song-flow",
      description:
        "Build your song-flow using any of the available methods — from Scripture, a theme, a lectionary reading, or by searching for songs directly. " +
        "Once you are happy with your selection, click <b>CURATE SONG-FLOW</b> to open your song-flow.",
    },
    {
      title: "Save your song-flow",
      description:
        "On the song-flow page, give your song-flow a name and click <b>Save</b>. Your song-flow will be saved to your account and you can return to it at any time.",
    },
    {
      title: "Access your saved song-flows",
      description:
        "To find your saved song-flows, click your name in the top-right navigation bar and select <b>View your saved song-flows</b>. " +
        "You will see a list of all your saved song-flows with their names and the date they were last updated.",
    },
    {
      title: "Managing your song-flows",
      description:
        "From your saved song-flows page you can open any song-flow to view or edit it, update its name or notes, and delete song-flows you no longer need. " +
        "You can save an unlimited number of song-flows on a paid account.",
    },
    {
      title: "What's next",
      description:
        "Your song-flows are now saved and ready to use." +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/sharing-a-song-flow'>Share a song-flow with your team</a>" +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> <a href='/help/reordering-songs-in-your-song-flow'>Reorder songs in your song-flow</a>" +
        "<br/><br/><img src=\"/help-images/star.png\" style=\"width: 40px; height: auto;\"> View our other <a href='/help'>help articles</a> for more guidance.",
      image: "/help-images/well-done.png",
      enlargeable: false,
    },
  ];

  render() {
    return (
      <>
        <SeoHelper
          uri="/help/saving-and-managing-your-song-flows"
          title="Saving and managing your song-flows | Help | The Worship Bible"
          description="How to save, access, and manage your curated song-flows as a registered member."
        />
        <div className="position-relative">
          <section className="section section-lg section-shaped pb-250">
            <div className="shape shape-style-1 shape-default">
              <span/><span/><span/><span/><span/><span/><span/><span/><span/>
            </div>
            <Container className="py-lg-md d-flex">
              <div className="col px-0">
                <Row>
                  <Col lg="8">
                    <h1 className="display-3 text-white">
                      Building your song-flows{" "}<span>help</span>
                    </h1>
                  </Col>
                </Row>
              </div>
            </Container>
            <div className="separator separator-bottom separator-skew">
              <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" version="1.1" viewBox="0 0 2560 100" x="0" y="0">
                <polygon className="fill-white" points="2560 0 2560 100 0 100"/>
              </svg>
            </div>
          </section>
        </div>
        <section className="section section-lg pt-lg-0 mt--200">
          <Container>
            <Row className="justify-content-center">
              <Col lg="12">
                <Row className="row-grid">
                  <Col lg="12">
                    <Card className="card-lift--hover shadow border-0">
                      <CardBody className="py-5">
                        <Row className="mt-3">
                          <Col>
                            <div className="d-flex align-items-center mb-3">
                              <RiFolderMusicLine color="#5e72e4" size="24" className="mr-2"/>
                              <h2 style={{fontSize: "1rem"}} className="text-primary mb-0">Saving and managing your song-flows</h2>
                            </div>
                          </Col>
                          <Col md="3" xs="12">
                            <Button block type="button" className="mb-2" color="white" href="/help">
                              <span className="btn-inner--text">Back to help</span>
                            </Button>
                          </Col>
                        </Row>
                        <InstructionsWizard stepsData={this.stepsData}/>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </>
    );
  }
}

export default SavingAndManagingYourSongFlowsHelp;
